import { createContext, useRef } from "react";

/**
 * Stores the DOM element for a react-select component that can be focused.
 * Allows us to have fine control over which element to focus and when.
 */
export const ReactSelectFocusManagerContext = createContext({
    focusedElement: null,
    focusElement: () => {},
});

export const ReactSelectFocusManager = ({ children }) => {
    const focusedElement = useRef(null);

    const focusElement = () => {
        // Ensure the input is visible and interactive
        // By default, react-select only sets these after the menu
        // has opened once
        if (focusedElement && focusedElement.current) {
            focusedElement.current.querySelector('input').focus();
            focusedElement.current.querySelector('input').style.width = '20px';
            focusedElement.current.querySelector('input').style.opacity = '1';
        }
    };

    return (
        <ReactSelectFocusManagerContext.Provider value={{ focusedElement, focusElement }}>
            {children}
        </ReactSelectFocusManagerContext.Provider>
    );
};
